module.exports = __webpack_public_path__ + "fonts/Gilroy-Black.3ee088eb.eot";